'use client';

import dynamic from 'next/dynamic';
import { normalizeLocale } from '@/i18n/config';
import translations from '@/i18n/marketing-showcase-copy.json';
import researchTranslations from '@/i18n/marketing-research-showcase-copy.json';
import { ShowcaseCarousel } from '../landing-showcase-carousel';
import { ShowcaseCopyContext } from '../collection-showcase/translation';
import '../collection-showcase/styles.css';
import './styles.css';

const ResearchAnimation = dynamic(() =>
  import('./scenes/research-animation').then((m) => m.ResearchAnimation)
);
const TeamChannelAnimation = dynamic(() =>
  import('./scenes/team-channel-animation').then((m) => m.TeamChannelAnimation)
);

export function ResearchShowcase({
  locale,
  label,
  controls,
}: {
  locale: string;
  label: string;
  controls: { previous: string; next: string };
}) {
  const language = normalizeLocale(locale);
  const copy = { ...translations[language], ...researchTranslations[language] };
  return (
    <ShowcaseCopyContext value={copy}>
      <ShowcaseCarousel
        label={label}
        roleDescription={copy.carousel}
        previousLabel={controls.previous}
        nextLabel={controls.next}
        slides={[
          {
            id: 'research',
            label: copy['Prediction & Research'],
            content: (
              <div className="collection-showcase research-showcase">
                <ResearchAnimation />
              </div>
            ),
          },
          {
            id: 'team-collaboration',
            label: copy['Team Collaboration with User Permissions'],
            content: (
              <div className="collection-showcase research-showcase">
                <TeamChannelAnimation />
              </div>
            ),
          },
        ]}
      />
    </ShowcaseCopyContext>
  );
}
